module.exports = __webpack_public_path__ + "static/media/handball.e034c4f8.jpg";